import React, { useState } from 'react';
import { styled } from '@glitz/react';
import Html from 'Shared/Partials/PropertyTypes/Html';
import { Paragraph, ResponsiveLineHeight, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import SizeInformationBlockViewModel from 'SizeInformation/SizeInformationBlockViewModel.type';
import Modal, { ModalScrollableContent, ModalTabs, ModalTopContent } from 'Shared/SharedComponents/atoms/Modal';

type RequiredPropType = {
  modalIsShown: boolean;
  hideModal: () => void;
  sizeInformation: SizeInformationBlockViewModel;
};

type PropType = RequiredPropType;

const Content = styled.div({
  paddingTop: '16px'
})

const Text = styled(Paragraph, {
  margin: { top: '24px' }
})

export const SizeGuideModal = ({ modalIsShown, hideModal, sizeInformation }: PropType) => {
  enum Tabs {
    SizeGuide,
    Measurement,
  }

  const tabs = [
    { tab: Tabs.SizeGuide, label: sizeInformation.sizeGuide?.tabText },
    { tab: Tabs.Measurement, label: sizeInformation.measurement?.tabText },
  ];

  const [selectedTab, setSelectedTab] = useState(Tabs.SizeGuide);

  return (
    <Modal modalIsShown={modalIsShown} hideModal={hideModal}>
      <ModalTopContent textAboveHeading={sizeInformation.label} heading={sizeInformation.heading} closeModal={hideModal}>
        <Text fontSize={ResponsiveSize.D20_M20} lineHeight={ResponsiveLineHeight.D120_M120}>
          {sizeInformation.intro}
        </Text>
        <ModalTabs tabs={tabs} activeTab={selectedTab} switchToTab={setSelectedTab} />
      </ModalTopContent>
      <ModalScrollableContent>
        {selectedTab === Tabs.SizeGuide && sizeInformation.sizeGuide?.mainBody && (
          <Content>
            <Html html={sizeInformation.sizeGuide.mainBody.html} />
          </Content>
        )}
        {selectedTab === Tabs.Measurement && sizeInformation.measurement?.mainBody && (
          <Content>
            <Html html={sizeInformation.measurement.mainBody.html} />
          </Content>
        )}
      </ModalScrollableContent>
    </Modal>
  );
};

export default SizeGuideModal;
